<div class="d-flex m-0 asset-actions">
  @if (enableSort) {
    <div class="asset-actions__sort">
      <div ngbDropdown class="asset-actions__dropdown">
        <button type="button" ngbDropdownToggle>
          <div class="d-flex gap-2 items-center">
            <span class="_400">{{ 'sortBy' | translate }}</span>
            <span class="_700 text-dark">{{ currentSort | translate }}</span>
          </div>
          <i class="fa fa-chevron-down text-dark ps-1" aria-hidden="true"></i>
        </button>
        <div ngbDropdownMenu>
          @for (item of sortActions; track item) {
            <button
              type="button"
              ngbDropdownItem
              (click)="item.action()"
              class="text-end asset-actions__dropdown__item">
              {{ item.name | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  }
  @if (enableFieldsFilter) {
    <div class="asset-actions__fields">
      <div
        ngbDropdown
        container="body"
        dropdownClass="z-9999"
        class="asset-actions__dropdown asset-actions__dropdown--border asset-actions__dropdown--filled">
        <button
          type="button"
          ngbDropdownToggle
          class="d-flex items-center justify-content-between py-1 px-2 gap-2 text-white">
          <div class="d-flex items-center gap-1">
            <span class="_400">Filter</span>
          </div>
          <i class="fa fa-chevron-down ps-1" aria-hidden="true"></i>
        </button>
        <div ngbDropdownMenu class="filter-card">
          <div class="p-1">
            @if (hasFocuses) {
              <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
                <button
                  type="button"
                  ngbDropdownToggle
                  class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                  [class.focus-dropdown]="selectedFocusValues?.length > 0">
                  <div class="d-flex items-center gap-1">
                    <button type="button" class="btn p-0 d-inline-block" (click)="onFocusToggle($event)">
                      <img [ngSrc]="focusDropdownPreIcon" width="14" height="14" alt="Focus filter icon" />
                    </button>
                    <span class="_400 f-10"> {{ 'Focus' | translate }}</span>
                  </div>
                  <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
                </button>
                @if (focusOptions?.length) {
                  <div ngbDropdownMenu>
                    @for (item of focusOptions; track item) {
                      <button type="button" class="btn asset-actions__dropdown__item" (click)="onFocusSelect(item)">
                        @if (selectedFocusValues.includes(item)) {
                          <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                        } @else {
                          <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                        }
                        {{ item }}
                      </button>
                    }
                  </div>
                }
              </div>
            }

            @if (hasTypes) {
              <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
                <button
                  type="button"
                  ngbDropdownToggle
                  class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                  [class.type-dropdown]="selectedTypeValues?.length > 0">
                  <div class="d-flex items-center gap-1">
                    <button type="button" class="btn p-0 d-inline-block" (click)="onTypeToggle($event)">
                      <img [ngSrc]="typeDropdownPreIcon" width="14" height="14" alt="Type filter icon" />
                    </button>
                    <span class="_400 f-10"> {{ 'Type' | translate }}</span>
                  </div>
                  <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
                </button>
                @if (typeOptions?.length) {
                  <div ngbDropdownMenu>
                    @for (item of typeOptions; track item) {
                      <button type="button" class="btn asset-actions__dropdown__item" (click)="onTypeSelect(item)">
                        @if (selectedTypeValues.includes(item)) {
                          <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                        } @else {
                          <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                        }
                        {{ item }}
                      </button>
                    }
                  </div>
                }
              </div>
            }
            <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
              <button
                type="button"
                ngbDropdownToggle
                class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                [class.bets-dropdown]="selectedBetsValues?.length > 0">
                <div class="d-flex items-center gap-1">
                  <button type="button" class="btn p-0 d-inline-block" (click)="onBetsToggle($event)">
                    <img [ngSrc]="betsDropdownPreIcon" width="14" height="14" alt="Platform filter icon" />
                  </button>
                  <span class="_400 f-10"> {{ 'Platform' | translate }}</span>
                </div>
                <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
              </button>
              @if (betsOptions?.length) {
                <div ngbDropdownMenu>
                  @for (item of betsOptions; track item) {
                    <button type="button" class="btn asset-actions__dropdown__item" (click)="onBetsSelect(item)">
                      @if (selectedBetsValues.includes(item)) {
                        <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                      } @else {
                        <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                      }
                      <i class="mtm-icon mtm-icon-{{ item.toLowerCase() }}"></i>
                      {{ item }}
                    </button>
                  }
                </div>
              }
            </div>
            <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
              <button
                type="button"
                ngbDropdownToggle
                class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                [class.status-dropdown]="selectedStatusValues?.length > 0">
                <div class="d-flex items-center gap-1">
                  <button type="button" class="btn p-0" (click)="onStatusToggle($event)">
                    <img [ngSrc]="statusDropdownPreIcon" width="14" height="14" alt="Status filter icon" />
                  </button>
                  <span class="_400 f-10"> {{ 'Status' | translate }}</span>
                </div>
                <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu>
                @for (item of filterStatusOptions; track item) {
                  <button type="button" class="btn asset-actions__dropdown__item" (click)="onStatusSelect(item)">
                    @if (selectedStatusValues.includes(item.value)) {
                      <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                    } @else {
                      <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                    }
                    <div class="project-status-display {{ item.value }}">
                      <i class="project-status-circle-color me-2"></i>
                      <span>{{ `task_${item.value}` | translate }}</span>
                    </div>
                  </button>
                }
              </div>
            </div>
            @if (availableYears?.length > 0) {
              <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
                <button
                  type="button"
                  ngbDropdownToggle
                  class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                  [class.release-date-dropdown]="selectedReleaseDateValues?.length > 0">
                  <div class="d-flex items-center gap-1">
                    <button type="button" class="btn p-0 d-inline-block" (click)="onReleaseToggle($event)">
                      <img [ngSrc]="releaseDateDropdownPreIcon" width="14" height="14" alt="Release date filter icon" />
                    </button>
                    <span class="_400 f-10"> {{ 'Release Date' | translate }}</span>
                  </div>
                  <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
                </button>
                <div ngbDropdownMenu class="release-date-menu">
                  @for (year of availableYears; track year) {
                    <div class="release-date-year">
                      <div class="d-flex align-items-center year-header px-2 py-2">
                        <button
                          type="button"
                          class="btn d-inline-block"
                          (click)="selectYear($event, year); $event.stopPropagation()">
                          <img
                            ngSrc="assets/svg/{{ yearSelected.includes(year) ? 'selected' : 'unselect' }}.svg"
                            width="14"
                            height="14"
                            [alt]="yearSelected.includes(year) ? 'Year selected' : 'Year unselected'"
                            class="year-checkbox me-2" />
                        </button>
                        <button
                          type="button"
                          class="btn year-label"
                          (click)="monthCollapse[year] = !monthCollapse[year]; $event.stopPropagation()">
                          {{ year }}
                        </button>
                        <button
                          type="button"
                          class="btn"
                          (click)="monthCollapse[year] = !monthCollapse[year]; $event.stopPropagation()">
                          <i [class.fa-rotate-180]="monthCollapse[year]" class="fa fa-chevron-down ms-auto"></i>
                        </button>
                      </div>

                      @if (monthCollapse[year]) {
                        <div class="month-list">
                          @for (month of availableMonthsPerYear[year] || months; track month) {
                            <button
                              type="button"
                              class="btn d-flex align-items-center month-item px-4 py-1"
                              (click)="monthSelected($event, year, month)">
                              <img
                                ngSrc="assets/svg/{{ releaseMonthYear[year]?.[month] ? 'selected' : 'unselect' }}.svg"
                                width="14"
                                height="14"
                                [alt]="releaseMonthYear[year]?.[month] ? 'Month selected' : 'Month unselected'"
                                class="month-checkbox me-2" />
                              <span>{{ getMonthName(month) }}</span>
                            </button>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
              <button
                type="button"
                ngbDropdownToggle
                class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                [class.duration-dropdown]="selectedDurationValues?.length > 0">
                <div class="d-flex items-center gap-1">
                  <button type="button" class="btn p-0 d-inline-block" (click)="onDurationToggle($event)">
                    <img [ngSrc]="durationDropdownPreIcon" width="14" height="14" alt="Duration filter icon" />
                  </button>
                  <span class="_400 f-10"> {{ 'Duration' | translate }}</span>
                </div>
                <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu>
                @for (item of durationOptions; track item) {
                  <button type="button" class="btn asset-actions__dropdown__item" (click)="onDurationSelect(item)">
                    @if (selectedDurationValues.includes(item)) {
                      <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                    } @else {
                      <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                    }
                    {{ item }}
                  </button>
                }
              </div>
            </div>
            <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
              <button
                type="button"
                ngbDropdownToggle
                class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                [class.format-dropdown]="selectedFormatValues?.length > 0">
                <div class="d-flex items-center gap-1">
                  <button type="button" class="btn p-0 d-inline-block" (click)="onFormatToggle($event)">
                    <img [ngSrc]="formatDropdownPreIcon" width="14" height="14" alt="Format filter icon" />
                  </button>
                  <span class="_400 f-10"> {{ 'Format' | translate }}</span>
                </div>
                <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu>
                @for (item of formatOptions; track item) {
                  <button type="button" class="btn asset-actions__dropdown__item" (click)="onFormatSelect(item)">
                    @if (selectedFormatValues.includes(item)) {
                      <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                    } @else {
                      <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                    }
                    {{ item }}
                  </button>
                }
              </div>
            </div>
            @if (hasAgencies) {
              <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
                <button
                  type="button"
                  ngbDropdownToggle
                  class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                  [class.categories-dropdown]="selectedCategoriesValues?.length > 0">
                  <div class="d-flex items-center gap-1">
                    <button type="button" class="btn p-0 d-inline-block" (click)="onCategoriesToggle($event)">
                      <img [ngSrc]="categoriesDropdownPreIcon" width="14" height="14" alt="Categories filter icon" />
                    </button>
                    <span class="_400 f-10"> {{ 'Categories' | translate }}</span>
                  </div>
                  <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
                </button>
                <div ngbDropdownMenu>
                  @for (item of categoriesOptions; track item) {
                    <button type="button" class="btn asset-actions__dropdown__item" (click)="onCategoriesSelect(item)">
                      @if (selectedCategoriesValues.includes(item)) {
                        <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                      } @else {
                        <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                      }
                      {{ item }}
                    </button>
                  }
                </div>
              </div>
            }
            <div class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
              <button
                type="button"
                class="d-flex btn w-100 items-center justify-content-between py-1 px-2 gap-2"
                [class.hidden-active]="showHiddenOnly"
                (click)="toggleHiddenFilter()">
                <div class="d-flex items-center gap-1">
                  <img
                    [ngSrc]="showHiddenOnly ? 'assets/svg/selected.svg' : 'assets/svg/unselect.svg'"
                    width="14"
                    height="14"
                    [alt]="showHiddenOnly ? 'Hidden assets selected' : 'Hidden assets unselected'" />
                  <span class="_400 f-10"> {{ 'Hidden Assets' | translate }}</span>
                </div>
              </button>
            </div>
            <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
              <button
                type="button"
                ngbDropdownToggle
                class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                [class.already-in-use-dropdown]="selectedInUseValues?.length > 0">
                <div class="d-flex items-center gap-1">
                  <button type="button" class="btn p-0 d-inline-block" (click)="onInUseToggle($event)">
                    <img [ngSrc]="inUseDropdownPreIcon" width="14" height="14" alt="Already in use filter icon" />
                  </button>
                  <span class="_400 f-10"> {{ 'Already in Use' | translate }}</span>
                </div>
                <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu>
                @for (item of inUseOptions; track item) {
                  <button type="button" class="btn asset-actions__dropdown__item" (click)="onInUseSelect(item)">
                    @if (selectedInUseValues.includes(item)) {
                      <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                    } @else {
                      <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                    }
                    {{ item }}
                  </button>
                }
              </div>
            </div>
            <div ngbDropdown class="asset-actions__dropdown" placement="right-bottom right-top left-bottom left-top">
              <button
                type="button"
                ngbDropdownToggle
                class="d-flex items-center justify-content-between py-1 px-2 gap-2"
                [class.project-dropdown]="selectedProjectIds?.length > 0">
                <div class="d-flex items-center gap-1">
                  <button type="button" class="btn p-0 d-inline-block" (click)="onProjectToggle($event)">
                    <img [ngSrc]="projectDropdownPreIcon" width="14" height="14" alt="Project filter icon" />
                  </button>
                  <span class="_400 f-10"> {{ 'project' | translate }}</span>
                </div>
                <i class="fa fa-chevron-right ps-1" aria-hidden="true"></i>
              </button>
              @if (projectOptions?.length) {
                <div ngbDropdownMenu>
                  @for (item of projectOptions; track item.id) {
                    <button type="button" class="btn asset-actions__dropdown__item" (click)="onProjectSelect(item.id)">
                      @if (selectedProjectIds.includes(item.id)) {
                        <img ngSrc="assets/svg/selected.svg" width="14" height="14" alt="Selected" />
                      } @else {
                        <img ngSrc="assets/svg/unselect.svg" width="14" height="14" alt="Unselected" />
                      }
                      {{ item.name.length > 30 ? `${(item.name | slice: 0 : 30)}...` : item.name }}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (enableOrientationSelection) {
    <div class="asset-actions__orientation">
      <div ngbDropdown class="asset-actions__dropdown asset-actions__dropdown--border">
        <button type="button" ngbDropdownToggle class="d-flex gap-2 px-2 py-1 justify-content-between">
          <span>{{ currentOrientation | translate }}</span>
          <i class="fa fa-chevron-down ps-1" aria-hidden="true"></i>
        </button>
        <div ngbDropdownMenu>
          @for (item of exportOrientationActions; track item) {
            <button
              type="button"
              ngbDropdownItem
              (click)="item.action()"
              class="btn text-end asset-actions__dropdown__item">
              {{ item.name | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  }
  @if (enableTextSearch) {
    <div class="asset-actions__search">
      <input
        type="text"
        placeholder="{{ 'search' | translate }}"
        [(ngModel)]="textSearch"
        (input)="textSearchChange.emit(textSearch)"
        (keydown)="onTextSearchEnter($event)" />
      <i class="fa fa-search search-icon" aria-hidden="true"></i>
    </div>
  }
  @if (enableExportAction) {
    <div class="asset-actions__export">
      <button
        type="button"
        class="d-flex items-center justify-content-center py-1 px-4 gap-2 bg-white border-0"
        style="border-radius: 8px"
        (click)="onOpenExportModal()">
        <mtm-export-icon />
        <span class="_700">{{ 'export' | translate | uppercase }}</span>
      </button>
    </div>
  }
  @if (enableManageAssetModels) {
    <div class="asset-actions__manage-models">
      <button
        type="button"
        class="d-flex items-center justify-content-center py-1 px-4 gap-2 bg-white border-0"
        style="border-radius: 8px"
        (click)="onOpenManageAssetModelsModal()">
        <img ngSrc="assets/img/ai-reframing/edit.svg" width="20" height="20" alt="Manage asset models" />
        <span class="_700">{{ 'MANAGE' | translate | uppercase }}</span>
      </button>
    </div>
  }
  @if (enableViewModeSwitching) {
    <div class="asset-actions__view">
      @for (item of viewActions; track item.name) {
        <button
          type="button"
          class="btn border-0 bg-transparent p-0 {{ item.name === viewMode ? '' : 'pointer opacity-30' }}"
          (click)="item.action()">
          <ng-container *ngComponentOutlet="item.icon"></ng-container>
        </button>
      }
    </div>
  }
</div>
